import { Add } from 'iconsax-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionCoreValueProposition = () => {
  const { t } = useTranslation();
  return (
    <section className="section-core-value-proposition">
      <div className="flex-content">
        <span className="label">{t('[Core Value Proposition]')}</span>
        <span className="value">
          {t(
            `Warppipe offers comprehensive solutions across various technology fields, from blockchain to artificial intelligence, web/mobile applications. We support business innovation by applying the optimal technology tailored to customers' business needs.`
          )}
        </span>
      </div>
      <div className="flex-between">
        <Add size="40" color="#98A2B3" />
        <Add size="40" color="#98A2B3" />
      </div>
    </section>
  );
};

export default React.memo(SectionCoreValueProposition);
